import React from "react";
import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";

export const MaskInput = ({
  classNameWrapper,
  type,
  defaultValue,
  control,
  name,
  idInput,
  placeholder,
  rules,
  labelHeader,
  describedby,
  disabled,
  mask,
  styles,
  errMessageToShow,
  maskChar = "_",
  handleChange,
}) => {
  /**
   * Mask Input.
   */

  return (
    <div className={`input-main-wrapper ${classNameWrapper || ""}`}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <div className="input-wrapper">
            {labelHeader && (
              <p className={`input-main-label-header`}>{labelHeader}</p>
            )}
            <div
              style={
                disabled
                  ? { borderColor: "#8CA2B8" }
                  : error || errMessageToShow
                  ? { border: "1px solid #d03325" }
                  : labelHeader && value
                  ? { border: "1px solid #0E9594" }
                  : {}
              }
              className="custom-input  custom-mask"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                  ...styles,
                }}
              >
                <InputMask
                  mask={mask || "(999) 999-9999"}
                  maskChar={maskChar}
                  value={value}
                  disabled={disabled}
                  onChange={handleChange || onChange}
                >
                  {() => (
                    <input
                      disabled={disabled}
                      value={value}
                      type={type}
                      className="input-form-control mask-input"
                      id={idInput}
                      aria-describedby={describedby}
                      placeholder={placeholder}
                    />
                  )}
                </InputMask>
              </div>
            </div>
            <p className="custom-error-messages">
              {errMessageToShow
                ? errMessageToShow
                : error?.type === "required"
                ? "This Field is required"
                : ""}
            </p>
          </div>
        )}
      />
    </div>
  );
};
